import { useCallback } from "react";
import { useWeb3React } from "@web3-react/core";
import {
	NoEthereumProviderError,
	UserRejectedRequestError,
} from "@web3-react/injected-connector";
import { connectorKey, WALLETS } from "../constants";

const useConnect = () => {
	const { activate, deactivate } = useWeb3React();

	const connect = useCallback(
		async (wallet) => {
			localStorage.setItem(connectorKey, wallet.name);

			await activate(wallet.connector, (err) => {
				console.log("Walletconnect ERR:", err);
				if (
					err instanceof NoEthereumProviderError ||
					err instanceof UserRejectedRequestError
				) {
					localStorage.removeItem(connectorKey);
				}
			});
		},
		[activate]
	);

	const disconnect = useCallback(async () => {
		localStorage.removeItem("connector");

		await deactivate();

		if (window.localStorage.getItem("walletconnect")) {
			const walletConnect = WALLETS.find(
				(wallet) => wallet.name === "Wallet Connect"
			);

			if (!!walletConnect) {
				const { connector } = walletConnect;

				connector.close();
				connector.walletConnectProvider = null;
			}
		}
	}, [deactivate]);

	return { connect, disconnect };
};

export { useConnect };
